






















import Vue, { PropType } from "vue";
import FloatingView from "@/components/Atoms/FloatingView/index.vue";
import Checkbox from "@/components/Atoms/Forms/Checkbox/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    FloatingView,
    Checkbox
  },
  model: {
    prop: "selectedGraduateYears",
    event: "input"
  },
  props: {
    graduateYear: {
      type: Number as PropType<Props["graduateYear"]>,
      required: true
    },
    selectedGraduateYears: {
      type: Array as PropType<Props["selectedGraduateYears"]>,
      required: true
    }
  },
  computed: {
    graduateYears() {
      if (!this.graduateYear) return [];
      return [...Array(3)].map((_, i) => this.graduateYear - i);
    }
  },
  methods: {
    getGraduateYearLabel(year) {
      return String(year).slice(2);
    },
    graduateYearClasses(year) {
      const diff = this.graduateYear - year;
      return [
        "graduateYearLegend__graduateYear",
        `graduateYearLegend__graduateYear--${diff}YearsAgo`
      ];
    },
    getCheckboxValue(year) {
      return this.selectedGraduateYears?.includes(year);
    },
    clickCheckbox(graduateYear) {
      this.$emit("input", Number(graduateYear));
    }
  }
});
